import { EmailIcon, SettingsIcon } from "@moznsystems/mozn-ui";
import {
	ArrowheadDownIcon,
	LogoutOutlineIcon,
	useClickAway,
} from "@rageeb/frontend-lib";
import { FC, useState } from "react";
import { NavLink } from "react-router-dom";
import { logout } from "@/auth";
import { ACCOUNT_SETTINGS_ROUTE } from "@/constants/routes";
import { useAuthStore } from "@/store/authStore";
import "./AccountPreview.scss";

const AccountPreview: FC = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { setUser, setIsGlobalLoader, user } = useAuthStore();

	const ref = useClickAway<HTMLDivElement>(() => {
		setIsOpen(false);
	});

	const handleOpen = () => {
		setIsOpen(!isOpen);
	};

	const onLogout = (e: React.MouseEvent<HTMLElement>) => {
		try {
			e.preventDefault();
			setIsGlobalLoader(true);
			setTimeout(async () => {
				await logout();
				setUser(null);
				setIsGlobalLoader(false);
			}, 1000);
		} catch {
			setIsGlobalLoader(false);
		}
	};

	return (
		<div className="account-preview" ref={ref}>
			<div
				className="account-preview--dropdown"
				onClick={handleOpen}
				id="account-preview--dropdown"
			>
				<span className="text">{`${user?.first_name} ${user?.last_name}`}</span>
				<ArrowheadDownIcon />
			</div>
			{isOpen && (
				<div
					className="account-preview--links"
					onClick={() => setIsOpen(false)}
				>
					<NavLink to={ACCOUNT_SETTINGS_ROUTE} className="item-link">
						<SettingsIcon version="2" />
						Account Settings
					</NavLink>
					<div className="separator"></div>

					<a
						href="mailto:support_focal@mozn.sa"
						rel="noreferrer"
						target="_blank"
						className="item-link"
					>
						<EmailIcon />
						Email us
					</a>

					<div className="separator"></div>

					<div className="item-link" onClick={onLogout}>
						<LogoutOutlineIcon />
						Log out
					</div>
				</div>
			)}
		</div>
	);
};

export { AccountPreview };
